export default "__VITE_ASSET__qNYLOsls__"